"use client";

import { c as _c } from "react/compiler-runtime";
import { LinkButton } from "@repo/ui/link-button";
import { useTranslations } from "next-intl";
interface DirectoryStatusBarProps {
  hasActiveFilters: boolean;
  isPending: boolean;
  total: number;
  label: string;
  onClearFilters: () => void;
}
export function DirectoryStatusBar(t0) {
  const $ = _c(24);
  const {
    hasActiveFilters,
    isPending,
    total,
    label,
    onClearFilters
  } = t0;
  const t = useTranslations("directory");
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== hasActiveFilters || $[1] !== isPending || $[2] !== label || $[3] !== onClearFilters || $[4] !== t || $[5] !== total) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = /s$/;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    const singularLabel = label.replace(t5, "");
    t3 = "col-span-full flex items-center justify-between";
    let t6;
    if ($[11] !== hasActiveFilters || $[12] !== onClearFilters || $[13] !== t) {
      t6 = hasActiveFilters && <LinkButton variant="primary" size="lg" underline={true} onClick={onClearFilters}>{t("clearFilters")}</LinkButton>;
      $[11] = hasActiveFilters;
      $[12] = onClearFilters;
      $[13] = t;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    if ($[15] !== t6) {
      t4 = <div>{t6}</div>;
      $[15] = t6;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t1 = "typography-component-xs-medium desktop:typography-component-md-medium text-cool-grey-400 pt-6";
    t2 = isPending ? t("loading") : t("showing", {
      total,
      label: total === 1 ? singularLabel : label
    });
    $[0] = hasActiveFilters;
    $[1] = isPending;
    $[2] = label;
    $[3] = onClearFilters;
    $[4] = t;
    $[5] = total;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[17] !== t1 || $[18] !== t2) {
    t5 = <p className={t1}>{t2}</p>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}